<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
<!--    返回-->

    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter" :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="检测时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段"
                          style="width: 100%" @on-ok="dateOk" @on-change="dateChange"
                          @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>

      <Table :columns="columns" stripe :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page"
            show-total @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import {deviceLogListApi} from '@/api/device/device'

export default {
  name: 'pigDeviceEnvironmentLogList',
  inject: ['reload'],
  data() {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        device_sn: '',
        search: '',
        ctime: [],
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '设备编号',
          key: 'device_sn',
          minWidth: 120
        },
        {
          title: '温度',
          minWidth: 100,
          render: (h, { row }) => {
            return h('div', row.monitoring.temperature ? row.monitoring.temperature : '-');
          }
        },
        {
          title: '湿度',
          minWidth: 100,
          render: (h, { row }) => {
            return h('div', row.monitoring.humidity ? row.monitoring.humidity : '-');
          }
        },
        {
          title: '二氧化碳',
          minWidth: 100,
          render: (h, { row }) => {
            return h('div', row.monitoring.co2 ? row.monitoring.co2 : '-');
          }
        },
        {
          title: '氨气',
          minWidth: 100,
          render: (h, { row }) => {
            return h('div', row.monitoring.nh3 ? row.monitoring.nh3 : '-');
          }
        },
        {
          title: '甲烷',
          minWidth: 100,
          render: (h, { row }) => {
            return h('div', row.monitoring.ch4 ? row.monitoring.ch4 : '-');
          }
        },
        {
          title: '检测时间',
          key: 'update_time',
          minWidth: 150
        },
      ]
    }
  },
  created() {
    if (this.$route.params.id !== '' && this.$route.params.id) {
      this.filter.device_sn = this.$route.params.id
      this.loadTableData()
    }
  },
  methods: {
    loadTableData() {
      this.loading = true
      deviceLogListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage(status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear() {
      this.filter.search = ''
      this.loadTableData()
    },
    // 下拉选择
    select(value) {
      this.loadTableData()
    },
    // 选择时间
    dateOk() {
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr) {
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear() {
      this.filter.ctime = []
      this.loadTableData()
    },
  }
}
</script>
